module.exports = __webpack_public_path__ + "static/media/Roland.8484eb05.jpg";